import { render } from "./HeaderNoAccess.vue?vue&type=template&id=3867831b"
import script from "./HeaderNoAccess.vue?vue&type=script&lang=js"
export * from "./HeaderNoAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__